import React from 'react';
import Accordion from '../accordion/Accordion';
import { connect } from 'react-redux';

class DataProperties extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formInputValues !== this.props.formInputValues) {
      this.setState({
        form:  this.props.formConfig
      })

      let { formInputValues, formConfig, selectedProject } = this.props
      let configCopy = Array.from(formConfig)
      
      let content = configCopy.map((config) => {
        if (formInputValues.length > 0) {
          let formData = formInputValues.find(object => object.category === config.form_id)
          config.data_from_db = formData ? formData : []
        } else {
          config.data_from_db = []
        }
        config.project_id = selectedProject.projectid
        return config
      })

      this.setState({
        data: content
      })
    }
  }

  renderAccordion = (project) => {
    if (project !== '') {
      return (
        <div id='projectData' className='d-block'>
          <Accordion data={this.state.data} size={this.props.size} show={this.props.show} />
        </div>
      )
    }
  }

render() {
  return (
    <>
      {
        this.renderAccordion(this.props.selectedProject)
      }
    </>
  )
}
}

const mapStateToProps = (state) => ({
  selectedProject: state.getSelectedProjectReducer.data,
  selectedModel: state.getSelectedModelReducer.data,
  formConfig: state.requestProjectDataConfig.data,
  formInputValues: state.postProjectData.data,
})

export default connect(mapStateToProps)(DataProperties)
